export interface CountryType {
  code: string;
  label: string;
  phone: string;
  currency: string;
  suggested?: boolean;
  noRegions?: boolean;
  isEU?: boolean;
}

export const countryTemplates = {
  UK: 'uk',
  TW: 'tw',
  IT: 'it',
};

const countries: readonly CountryType[] = [
  { code: 'AD', label: 'Andorra', phone: '+376', currency: 'EUR' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '+971',
    currency: 'AED',
  },
  { code: 'AF', label: 'Afghanistan', phone: '+93', currency: 'AFN' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '+1-268',
    currency: 'XCD',
  },
  { code: 'AI', label: 'Anguilla', phone: '+1-264', currency: 'XCD' },
  { code: 'AL', label: 'Albania', phone: '+355', currency: 'ALL' },
  { code: 'AM', label: 'Armenia', phone: '+374', currency: 'AMD' },
  { code: 'AO', label: 'Angola', phone: '+244', currency: 'AOA' },
  { code: 'AQ', label: 'Antarctica', phone: '+672', currency: 'N/A' },
  { code: 'AR', label: 'Argentina', phone: '+54', currency: 'ARS' },
  { code: 'AS', label: 'American Samoa', phone: '+1-684', currency: 'USD' },
  { code: 'AT', label: 'Austria', phone: '+43', currency: 'EUR', isEU: true },
  {
    code: 'AU',
    label: 'Australia',
    phone: '+61',
    currency: 'AUD',
    suggested: true,
  },
  { code: 'AW', label: 'Aruba', phone: '+297', currency: 'AWG' },
  { code: 'AZ', label: 'Azerbaijan', phone: '+994', currency: 'AZN' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '+387',
    currency: 'BAM',
  },
  { code: 'BB', label: 'Barbados', phone: '+1-246', currency: 'BBD' },
  { code: 'BD', label: 'Bangladesh', phone: '+880', currency: 'BDT' },
  { code: 'BE', label: 'Belgium', phone: '+32', currency: 'EUR', isEU: true },
  { code: 'BF', label: 'Burkina Faso', phone: '+226', currency: 'XOF' },
  { code: 'BG', label: 'Bulgaria', phone: '+359', currency: 'BGN', isEU: true },
  { code: 'BH', label: 'Bahrain', phone: '+973', currency: 'BHD' },
  { code: 'BI', label: 'Burundi', phone: '+257', currency: 'BIF' },
  { code: 'BJ', label: 'Benin', phone: '+229', currency: 'XOF' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '+590', currency: 'EUR' },
  { code: 'BM', label: 'Bermuda', phone: '+1-441', currency: 'BMD' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '+673', currency: 'BND' },
  { code: 'BO', label: 'Bolivia', phone: '+591', currency: 'BOB' },
  { code: 'BR', label: 'Brazil', phone: '+55', currency: 'BRL' },
  { code: 'BS', label: 'Bahamas', phone: '+1-242', currency: 'BSD' },
  { code: 'BT', label: 'Bhutan', phone: '+975', currency: 'BTN' },
  { code: 'BW', label: 'Botswana', phone: '+267', currency: 'BWP' },
  { code: 'BY', label: 'Belarus', phone: '+375', currency: 'BYN' },
  { code: 'BZ', label: 'Belize', phone: '+501', currency: 'BZD' },
  { code: 'CA', label: 'Canada', phone: '+1', currency: 'CAD' },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '+243',
    currency: 'CDF',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '+236',
    currency: 'XAF',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '+242',
    currency: 'XAF',
  },
  { code: 'CH', label: 'Switzerland', phone: '+41', currency: 'CHF' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '+225', currency: 'XOF' },
  { code: 'CK', label: 'Cook Islands', phone: '+682', currency: 'NZD' },
  { code: 'CL', label: 'Chile', phone: '+56', currency: 'CLP' },
  { code: 'CM', label: 'Cameroon', phone: '+237', currency: 'XAF' },
  { code: 'CN', label: 'China', phone: '+86', currency: 'CNY' },
  { code: 'CO', label: 'Colombia', phone: '+57', currency: 'COP' },
  { code: 'CR', label: 'Costa Rica', phone: '+506', currency: 'CRC' },
  { code: 'CV', label: 'Cape Verde', phone: '+238', currency: 'CVE' },
  { code: 'CW', label: 'Curacao', phone: '+599', currency: 'ANG' },
  { code: 'CY', label: 'Cyprus', phone: '+357', currency: 'EUR', isEU: true },
  { code: 'CZ', label: 'Czech Republic', phone: '+420', currency: 'CZK', isEU: true },
  {
    code: 'DE',
    label: 'Germany',
    phone: '+49',
    currency: 'EUR',
    suggested: true,
    isEU: true,
  },
  { code: 'DJ', label: 'Djibouti', phone: '+253', currency: 'DJF' },
  { code: 'DK', label: 'Denmark', phone: '+45', currency: 'DKK', isEU: true },
  { code: 'DM', label: 'Dominica', phone: '+1-767', currency: 'XCD' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '+1-809',
    currency: 'DOP',
  },
  { code: 'DZ', label: 'Algeria', phone: '+213', currency: 'DZD' },
  { code: 'EC', label: 'Ecuador', phone: '+593', currency: 'USD' },
  { code: 'EE', label: 'Estonia', phone: '+372', currency: 'EUR', isEU: true },
  { code: 'EG', label: 'Egypt', phone: '+20', currency: 'EGP' },
  { code: 'ER', label: 'Eritrea', phone: '+291', currency: 'ERN' },
  { code: 'ES', label: 'Spain', phone: '+34', currency: 'EUR', isEU: true },
  { code: 'ET', label: 'Ethiopia', phone: '+251', currency: 'ETB' },
  { code: 'FI', label: 'Finland', phone: '+358', currency: 'EUR', isEU: true },
  { code: 'FJ', label: 'Fiji', phone: '+679', currency: 'FJD' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '+500',
    currency: 'FKP',
    noRegions: true,
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '+691',
    currency: 'USD',
  },
  { code: 'FO', label: 'Faroe Islands', phone: '+298', currency: 'DKK' },
  {
    code: 'FR',
    label: 'France',
    phone: '+33',
    currency: 'EUR',
    suggested: true,
    isEU: true,
  },
  { code: 'GA', label: 'Gabon', phone: '+241', currency: 'XAF' },
  { code: 'GB', label: 'United Kingdom', phone: '+44', currency: 'GBP' },
  { code: 'GD', label: 'Grenada', phone: '+1-473', currency: 'XCD' },
  { code: 'GE', label: 'Georgia', phone: '+995', currency: 'GEL' },
  { code: 'GF', label: 'French Guiana', phone: '+594', currency: 'EUR' },
  { code: 'GG', label: 'Guernsey', phone: '+44', currency: 'GBP' },
  { code: 'GH', label: 'Ghana', phone: '+233', currency: 'GHS' },
  { code: 'GI', label: 'Gibraltar', phone: '+350', currency: 'GIP', noRegions: true },
  { code: 'GL', label: 'Greenland', phone: '+299', currency: 'DKK' },
  { code: 'GM', label: 'Gambia', phone: '+220', currency: 'GMD' },
  { code: 'GN', label: 'Guinea', phone: '+224', currency: 'GNF' },
  { code: 'GP', label: 'Guadeloupe', phone: '+590', currency: 'EUR' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '+240', currency: 'XAF' },
  { code: 'GR', label: 'Greece', phone: '+30', currency: 'EUR', isEU: true },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '+500',
    currency: 'GBP',
    noRegions: true,
  },
  { code: 'GT', label: 'Guatemala', phone: '+502', currency: 'GTQ' },
  { code: 'GU', label: 'Guam', phone: '+1-671', currency: 'USD' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '+245', currency: 'XOF' },
  { code: 'GY', label: 'Guyana', phone: '+592', currency: 'GYD' },
  { code: 'HK', label: 'Hong Kong', phone: '+852', currency: 'HKD' },
  { code: 'HN', label: 'Honduras', phone: '+504', currency: 'HNL' },
  { code: 'HR', label: 'Croatia', phone: '+385', currency: 'HRK', isEU: true },
  { code: 'HT', label: 'Haiti', phone: '+509', currency: 'HTG' },
  { code: 'HU', label: 'Hungary', phone: '3+6', currency: 'HUF', isEU: true },
  {
    code: 'IC',
    label: 'Canary Islands',
    phone: '+34',
    currency: 'EUR',
    isEU: true,
    noRegions: true,
  },
  { code: 'ID', label: 'Indonesia', phone: '+62', currency: 'IDR' },
  { code: 'IE', label: 'Ireland', phone: '+353', currency: 'EUR', isEU: true },
  { code: 'IL', label: 'Israel', phone: '+972', currency: 'ILS' },
  { code: 'IN', label: 'India', phone: '+91', currency: 'INR' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '+246',
    currency: 'USD',
    noRegions: true,
  },
  { code: 'IQ', label: 'Iraq', phone: '+964', currency: 'IQD' },
  { code: 'IS', label: 'Iceland', phone: '+354', currency: 'ISK' },
  { code: 'IM', label: 'Isle of Man', phone: '+44', currency: 'GBP' },
  { code: 'IT', label: 'Italy', phone: '+39', currency: 'EUR', isEU: true },
  { code: 'JE', label: 'Jersey', phone: '+44', currency: 'GBP' },
  { code: 'JM', label: 'Jamaica', phone: '+1-876', currency: 'JMD' },
  { code: 'JO', label: 'Jordan', phone: '+962', currency: 'JOD' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '+81',
    currency: 'JPY',
    suggested: true,
  },
  { code: 'KE', label: 'Kenya', phone: '+254', currency: 'KES' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '+996', currency: 'KGS' },
  { code: 'KH', label: 'Cambodia', phone: '+855', currency: 'KHR' },
  { code: 'KI', label: 'Kiribati', phone: '+686', currency: 'AUD' },
  { code: 'KM', label: 'Comoros', phone: '+269', currency: 'KMF' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '+1-869',
    currency: 'XCD',
  },
  { code: 'KR', label: 'Korea, Republic of', phone: '+82', currency: 'KRW' },
  { code: 'KW', label: 'Kuwait', phone: '+965', currency: 'KWD' },
  { code: 'KY', label: 'Cayman Islands', phone: '+1-345', currency: 'KYD' },
  {
    code: 'LA',
    label: "Lao People's Democratic Republic",
    phone: '+856',
    currency: 'LAK',
  },
  { code: 'LB', label: 'Lebanon', phone: '+961', currency: 'LBP' },
  { code: 'LC', label: 'Saint Lucia', phone: '+1-758', currency: 'XCD' },
  { code: 'LI', label: 'Liechtenstein', phone: '+423', currency: 'CHF' },
  { code: 'LK', label: 'Sri Lanka', phone: '+94', currency: 'LKR' },
  { code: 'LR', label: 'Liberia', phone: '+231', currency: 'LRD' },
  { code: 'LS', label: 'Lesotho', phone: '+266', currency: 'LSL' },
  { code: 'LT', label: 'Lithuania', phone: '+370', currency: 'EUR', isEU: true },
  { code: 'LU', label: 'Luxembourg', phone: '+352', currency: 'EUR', isEU: true },
  { code: 'LV', label: 'Latvia', phone: '+371', currency: 'EUR', isEU: true },
  { code: 'LY', label: 'Libya', phone: '+218', currency: 'LYD' },
  { code: 'MA', label: 'Morocco', phone: '+212', currency: 'MAD' },
  { code: 'MC', label: 'Monaco', phone: '+377', currency: 'EUR' },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '+373',
    currency: 'MDL',
  },
  { code: 'ME', label: 'Montenegro', phone: '+382', currency: 'EUR' },
  { code: 'MG', label: 'Madagascar', phone: '+261', currency: 'MGA' },
  { code: 'MH', label: 'Marshall Islands', phone: '+692', currency: 'USD' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '+389',
    currency: 'MKD',
  },
  { code: 'ML', label: 'Mali', phone: '+223', currency: 'XOF' },
  { code: 'MM', label: 'Myanmar', phone: '+95', currency: 'MMK' },
  { code: 'MN', label: 'Mongolia', phone: '+976', currency: 'MNT' },
  { code: 'MO', label: 'Macao', phone: '+853', currency: 'MOP' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '+1-670',
    currency: 'USD',
  },
  { code: 'MQ', label: 'Martinique', phone: '+596', currency: 'EUR' },
  { code: 'MR', label: 'Mauritania', phone: '+222', currency: 'MRU' },
  { code: 'MS', label: 'Montserrat', phone: '+1-664', currency: 'XCD' },
  { code: 'MT', label: 'Malta', phone: '+356', currency: 'EUR', isEU: true },
  { code: 'MU', label: 'Mauritius', phone: '+230', currency: 'MUR' },
  { code: 'MV', label: 'Maldives', phone: '+960', currency: 'MVR' },
  { code: 'MW', label: 'Malawi', phone: '+265', currency: 'MWK' },
  { code: 'MX', label: 'Mexico', phone: '+52', currency: 'MXN' },
  { code: 'MY', label: 'Malaysia', phone: '+60', currency: 'MYR' },
  { code: 'MZ', label: 'Mozambique', phone: '+258', currency: 'MZN' },
  { code: 'NA', label: 'Namibia', phone: '+264', currency: 'NAD' },
  { code: 'NC', label: 'New Caledonia', phone: '+687', currency: 'XPF' },
  { code: 'NE', label: 'Niger', phone: '+227', currency: 'XOF' },
  { code: 'NG', label: 'Nigeria', phone: '+234', currency: 'NGN' },
  { code: 'NI', label: 'Nicaragua', phone: '+505', currency: 'NIO' },
  { code: 'NL', label: 'Netherlands', phone: '+31', currency: 'EUR', isEU: true },
  { code: 'NO', label: 'Norway', phone: '+47', currency: 'NOK' },
  { code: 'NP', label: 'Nepal', phone: '+977', currency: 'NPR' },
  { code: 'NR', label: 'Nauru', phone: '+674', currency: 'AUD' },
  { code: 'NU', label: 'Niue', phone: '+683', currency: 'NZD' },
  { code: 'NZ', label: 'New Zealand', phone: '+64', currency: 'NZD' },
  { code: 'OM', label: 'Oman', phone: '+968', currency: 'OMR' },
  { code: 'PA', label: 'Panama', phone: '+507', currency: 'PAB' },
  { code: 'PE', label: 'Peru', phone: '+51', currency: 'PEN' },
  { code: 'PF', label: 'French Polynesia', phone: '+689', currency: 'XPF' },
  { code: 'PG', label: 'Papua New Guinea', phone: '+675', currency: 'PGK' },
  { code: 'PH', label: 'Philippines', phone: '+63', currency: 'PHP' },
  { code: 'PK', label: 'Pakistan', phone: '+92', currency: 'PKR' },
  { code: 'PL', label: 'Poland', phone: '+48', currency: 'PLN', isEU: true },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '+508',
    currency: 'EUR',
  },
  { code: 'PN', label: 'Pitcairn', phone: '+870', currency: 'NZD', noRegions: true },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '+970',
    currency: 'ILS',
  },
  { code: 'PT', label: 'Portugal', phone: '+351', currency: 'EUR', isEU: true },
  { code: 'PW', label: 'Palau', phone: '+680', currency: 'USD' },
  { code: 'PY', label: 'Paraguay', phone: '+595', currency: 'PYG' },
  { code: 'QA', label: 'Qatar', phone: '+974', currency: 'QAR' },
  { code: 'RE', label: 'Reunion', phone: '+262', currency: 'EUR' },
  { code: 'RO', label: 'Romania', phone: '+40', currency: 'RON', isEU: true },
  { code: 'RS', label: 'Serbia', phone: '+381', currency: 'RSD' },
  { code: 'RU', label: 'Russian Federation', phone: '+7', currency: 'RUB' },
  { code: 'RW', label: 'Rwanda', phone: '+250', currency: 'RWF' },
  { code: 'SA', label: 'Saudi Arabia', phone: '+966', currency: 'SAR' },
  { code: 'SB', label: 'Solomon Islands', phone: '+677', currency: 'SBD' },
  { code: 'SC', label: 'Seychelles', phone: '+248', currency: 'SCR' },
  { code: 'SD', label: 'Sudan', phone: '+249', currency: 'SDG' },
  { code: 'SE', label: 'Sweden', phone: '+46', currency: 'SEK', isEU: true },
  { code: 'SG', label: 'Singapore', phone: '+65', currency: 'SGD' },
  {
    code: 'SH',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    phone: '+290',
    currency: 'SHP',
  },
  { code: 'SI', label: 'Slovenia', phone: '+386', currency: 'EUR', isEU: true },
  { code: 'SK', label: 'Slovakia', phone: '+421', currency: 'EUR', isEU: true },
  { code: 'SL', label: 'Sierra Leone', phone: '+232', currency: 'SLL' },
  { code: 'SM', label: 'San Marino', phone: '+378', currency: 'EUR' },
  { code: 'SN', label: 'Senegal', phone: '+221', currency: 'XOF' },
  { code: 'SO', label: 'Somalia', phone: '+252', currency: 'SOS' },
  { code: 'SR', label: 'Suriname', phone: '+597', currency: 'SRD' },
  { code: 'SS', label: 'South Sudan', phone: '+211', currency: 'SSP' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '+239',
    currency: 'STN',
  },
  { code: 'SV', label: 'El Salvador', phone: '+503', currency: 'USD' },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '+1-721',
    currency: 'ANG',
  },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '+590',
    currency: 'EUR',
  },
  { code: 'SZ', label: 'Swaziland', phone: '+268', currency: 'SZL' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '+1-649',
    currency: 'USD',
  },
  { code: 'TD', label: 'Chad', phone: '+235', currency: 'XAF' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '+262',
    currency: 'EUR',
    noRegions: true,
  },
  { code: 'TG', label: 'Togo', phone: '+228', currency: 'XOF' },
  { code: 'TH', label: 'Thailand', phone: '+66', currency: 'THB' },
  { code: 'TJ', label: 'Tajikistan', phone: '+992', currency: 'TJS' },
  { code: 'TK', label: 'Tokelau', phone: '+690', currency: 'NZD' },
  { code: 'TL', label: 'Timor-Leste', phone: '+670', currency: 'USD' },
  { code: 'TM', label: 'Turkmenistan', phone: '+993', currency: 'TMT' },
  { code: 'TN', label: 'Tunisia', phone: '+216', currency: 'TND' },
  { code: 'TO', label: 'Tonga', phone: '+676', currency: 'TOP' },
  { code: 'TR', label: 'Turkey', phone: '+90', currency: 'TRY' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '+1-868',
    currency: 'TTD',
  },
  { code: 'TV', label: 'Tuvalu', phone: '+688', currency: 'AUD' },
  {
    code: 'TW',
    label: 'Taiwan',
    phone: '+886',
    currency: 'TWD',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '+255',
    currency: 'TZS',
  },
  { code: 'UG', label: 'Uganda', phone: '+256', currency: 'UGX' },
  {
    code: 'US',
    label: 'United States',
    phone: '+1',
    currency: 'USD',
    suggested: true,
  },
  { code: 'UY', label: 'Uruguay', phone: '+598', currency: 'UYU' },
  { code: 'UZ', label: 'Uzbekistan', phone: '+998', currency: 'UZS' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '+379',
    currency: 'EUR',
    noRegions: true,
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '+1-784',
    currency: 'XCD',
  },
  { code: 'VE', label: 'Venezuela', phone: '+58', currency: 'VES' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '+1-284',
    currency: 'USD',
    noRegions: true,
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '+1-340',
    currency: 'USD',
  },
  { code: 'VN', label: 'Vietnam', phone: '+84', currency: 'VND' },
  { code: 'VU', label: 'Vanuatu', phone: '+678', currency: 'VUV' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '+681', currency: 'XPF' },
  { code: 'WS', label: 'Samoa', phone: '+685', currency: 'WST' },
  { code: 'XK', label: 'Kosovo', phone: '+383', currency: 'EUR' },
  { code: 'YE', label: 'Yemen', phone: '+967', currency: 'YER' },
  { code: 'YT', label: 'Mayotte', phone: '+262', currency: 'EUR' },
  { code: 'ZA', label: 'South Africa', phone: '+27', currency: 'ZAR' },
  { code: 'ZM', label: 'Zambia', phone: '+260', currency: 'ZMW' },
  { code: 'ZW', label: 'Zimbabwe', phone: '+263', currency: 'ZWL' },
  { code: 'KZ', label: 'Kazakhstan', phone: '+7', currency: 'KZT' },
];

export default countries;
